<avano-menu
  [appVersion]="appVersion"
  [menuEntries]="menuEntries"
  [collapsed]="initialCollapseState | async"
  (collapsedChange)="changedCollapse($event)"
></avano-menu>
